export enum SINGLE_SPA_ROUTE_TYPE {
  ROUTE = "route",
  APPLICATION = "application",
}

export interface SingleSpaRoute {
  type: SINGLE_SPA_ROUTE_TYPE;
  path?: string;
  name?: string;
  exact?: boolean;
  routes?: SingleSpaRoute[];
}

export interface DRSRoute {
  application_identifier?: string;
  navigation_group?: DRSNavigationGroup;
  order: number;
  name: string;
  assets?: string;
  icon: string;
  path?: string;
  launch_point: string;
  access_roles: string[];
  is_route_public?: boolean;
  is_header_enabled?: boolean;
  attached_to_menu: boolean;
  is_path_exact?: boolean;
  is_redirect: boolean;
}

export interface DRSNavigationGroup {
  name: string;
  icon: string;
}

export interface DRSApplication {
  identifier: string;
  uri: string;
  available_interfaces: string[];
  shared_libraries_version: string;
}
export interface DRSConfiguration {
  applications: DRSApplication[];
}

export interface NavigationItem {
  title: string;
  icon: string;
  launchPoint: string;
  path?: string;
  isRedirect: boolean;
}

export interface NavigationGroup {
  name: string;
  icon: string;
  items: NavigationItem[];
}

export type NavigationRow = NavigationItem | NavigationGroup;

export interface ImportMap {
  imports: string[];
}
